var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9668 10.3105L19.1328 2.35059C20.7119 1.60938 21.958 2.7373 21.2275 4.32715L13.2891 21.3965C12.5693 22.9541 10.5498 22.6533 10.5391 20.9561L10.5176 13.1895C10.5176 13.0605 10.4854 13.0283 10.3564 13.0283L2.52539 12.9961C0.892578 12.9854 0.484375 10.998 1.9668 10.3105ZM3.83594 11.3203L11.4199 11.2773C11.9033 11.2773 12.2363 11.6104 12.2363 12.083L12.1826 19.6777C12.1826 19.7207 12.2256 19.7314 12.2363 19.6885L19.3477 4.2627C19.3799 4.17676 19.3477 4.15527 19.2725 4.1875L3.83594 11.2559C3.78223 11.2773 3.79297 11.3203 3.83594 11.3203Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOutline);
export default __webpack_public_path__ + "static/media/location-outline.89e6547e63288c7345719603ca5fd276.svg";
export { ForwardRef as ReactComponent };